import { createSelector } from 'reselect';

import { EContactStatuses } from '@r1-frontend/api-domru/api-profile/v2/info/all/dto/ResponseDto';
import { IClientContact, IClientContacts, TState } from '@r1-frontend/entities/stores/auth/reducer';

export const selectClientContacts = (state: TState): IClientContacts | null => {
    return state.auth.clientContacts || null;
};

export const selectClientContactsEmail = createSelector(
    selectClientContacts,
    (items) => {
        const emails = items?.email;
            return emails || [];
    },
);

export const selectClientContactsEmailConfirmed = createSelector(
    selectClientContacts,
    (items) => {
        let result: IClientContact[] = [];
        const emails = items?.email;
        if (emails) {
            result = emails.reduce((acc, val) => {
                    if (val.status === EContactStatuses.confirmed) {
                        acc.push(val);
                    }
                    return acc;
                }, <IClientContact[]>[]);
        }
        return result;
    },
);

export const selectClientContactsPhone = createSelector(
    selectClientContacts,
    (items) => {
        const emails = items?.email;
        return emails || [];
    },
);


